import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  BooleanField,
  ReferenceField,
  Filter,
  TextInput,
  BooleanInput
} from "react-admin";
import { Pagination } from "react-admin";

const CustomPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;
const PostFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Campaign" source="campaign"/>
    <BooleanInput label="Expired" source="expired"/>
  </Filter>
);
export const CouponList = (props) => (
  <List {...props} title="Users" pagination={<CustomPagination/>} perPage={30} filters={<PostFilter/>}>
    <Datagrid>
      <TextField source="originId" label="ID"/>
      <ReferenceField label="Campaign" source="campaign" reference="campaigns">
        <TextField source="title"/>
      </ReferenceField>
      <BooleanField source="expired"/>
      <TextField source="code" label="Coupon code"/>
      <TextField source="description" label="Coupon description"/>
      <ShowButton/>
      <EditButton/>
    </Datagrid>
  </List>
);
